import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../../components/header'
import Footer from '../../components/footer'
import Whatsapp from '../../components/whatsapp'
import './direito-imobilirio.css'

const DireitoImobilirio = (props) => {
  return (
    <div className="direito-imobilirio-container10">
      <Helmet>
        <title>Direito-Imobilirio - Adv. Wanderson H Cavalari - Cuiabá</title>
        <meta
          name="description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
        <meta
          property="og:title"
          content="Direito-Imobilirio - Adv. Wanderson H Cavalari - Cuiabá"
        />
        <meta
          property="og:description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
      </Helmet>
      <div className="direito-imobilirio-container11">
        <main className="direito-imobilirio-container12">
          <div className="direito-imobilirio-container13">
            <Header rootClassName="headerroot-class-name14"></Header>
            <div className="direito-imobilirio-container14">
              <div className="direito-imobilirio-frame46">
                <span className="direito-imobilirio-text10">
                  ÁREA DE ATUAÇÃO
                </span>
                <span className="direito-imobilirio-text11">Direito</span>
                <span className="direito-imobilirio-text12">Imobiliário</span>
                <span className="direito-imobilirio-text13">
                  A advocacia imobiliária abrange a assessoria legal em
                  transações de compra, venda e locação de imóveis, incluindo
                  due diligence, elaboração e revisão de contratos, e resolução
                  de litígios relacionados a propriedades.
                </span>
              </div>
              <div className="direito-imobilirio-container15">
                <span className="direito-imobilirio-text14">
                  <span>Fale Comigo</span>
                </span>
                <span className="direito-imobilirio-text16 Content">
                  Quer saber mais sobre esta área de atuação? Mande-me uma
                  mensagem para introduzirmos esta questão
                </span>
                <iframe
                  src="https://whc-dun.vercel.app/email"
                  scrolling="no"
                  className="direito-imobilirio-iframe"
                ></iframe>
              </div>
            </div>
          </div>
          <div className="direito-imobilirio-container16">
            <div className="direito-imobilirio-container17">
              <div className="direito-imobilirio-frame86">
                <div className="direito-imobilirio-container18">
                  <div className="direito-imobilirio-container19">
                    <span className="direito-imobilirio-text17">
                      Ação de Adjudicação Compulsória
                    </span>
                    <span className="direito-imobilirio-text18">
                      A ação de adjudicação compulsória garante ao comprador
                      o direito de obter a escritura definitiva quando o
                      vendedor se recusa a outorgá-la após o pagamento integral
                      do preço, efetivando a transferência da propriedade.
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/imob-adjudicacao.jpg"
                    loading="eager"
                    className="direito-imobilirio-image1"
                  />
                </div>
                <div className="direito-imobilirio-container20">
                  <div className="direito-imobilirio-container21">
                    <span className="direito-imobilirio-text19">
                      <span>Ação de Consignação de Chaves do Imóvel</span>
                      <br></br>
                    </span>
                    <span className="direito-imobilirio-text22">
                      Uma ação de consignação de chaves do imóvel é uma medida
                      legal que um locatário pode tomar quando enfrenta
                      dificuldades para devolver as chaves do imóvel ao locador.
                      Isso pode acontecer, por exemplo, quando o locador se
                      recusa a receber as chaves ou quando há desacordo sobre o
                      estado de conservação do imóvel.
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/imob-consignacao-chaves.jpg"
                    loading="eager"
                    className="direito-imobilirio-image2"
                  />
                </div>
                <div className="direito-imobilirio-container22">
                  <img
                    alt="image"
                    src="/imob-despejo.jpg"
                    loading="eager"
                    className="direito-imobilirio-image3"
                  />
                  <div className="direito-imobilirio-container23">
                    <span className="direito-imobilirio-text23">
                      Ação de Despejo
                    </span>
                    <span className="direito-imobilirio-text24">
                      <span>
                        Seja por qual motivo for, o locador nunca pode retirar o
                        locatário do imóvel por meios forçosos ou arbitrários,
                        sendo necessário o crivo do judiciário. Assim sendo, a
                        ação do locador para reaver o imóvel é a ação de despejo
                        (Artigo 5º da Lei 8.245/91).
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
                <div className="direito-imobilirio-container24">
                  <img
                    alt="image"
                    src="/imob-reintegracao.jpg"
                    loading="eager"
                    className="direito-imobilirio-image4"
                  />
                  <div className="direito-imobilirio-container25">
                    <span className="direito-imobilirio-text27">
                      <span>Ação de Reintegração de Posse</span>
                      <br></br>
                    </span>
                    <span className="direito-imobilirio-text30">
                      <span>
                        Chamada também de ação de esbulho possessório, a
                        reintegração de posse é uma ação judicial especial, cujo
                        objetivo é devolver a posse de uma propriedade para uma
                        pessoa que a perdeu por algum motivo.
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
                <div className="direito-imobilirio-container26">
                  <div className="direito-imobilirio-container27">
                    <span className="direito-imobilirio-text33">
                      Ação de Imissão na Posse
                    </span>
                    <span className="direito-imobilirio-text34">
                      A ação de imissão na posse é uma medida judicial para
                      casos em que uma pessoa adquire um imóvel, mas, por algum
                      motivo, tem o seu direito de usufruto privado. Na maioria
                      das vezes, ao comprar um imóvel a pessoa é imitida na
                      posse assim que realiza o pagamento. Entretanto, em alguns
                      casos, apesar de deter a propriedade do imóvel, a pessoa
                      pode ter seu direito de usufruir privado. Por exemplo,
                      quando alguém adquire o imóvel em um leilão, mas existem
                      pessoas vivendo no local. Neste caso, o proprietário acaba
                      por não deter a posse do imóvel. Para resolver a situação,
                      então, o proprietário entra com uma medida judicial a fim
                      de recuperar a posse do imóvel.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/imob-imissao.jpg"
                    loading="eager"
                    className="direito-imobilirio-image5"
                  />
                </div>
                <div className="direito-imobilirio-container28">
                  <div className="direito-imobilirio-container29">
                    <span className="direito-imobilirio-text35">
                      <span>Ação Revisional de Contrato de Aluguel</span>
                      <br></br>
                    </span>
                    <span className="direito-imobilirio-text38">
                      A Ação Revisional tem por objetivo ajustar o valor da
                      locação, sendo comercial ou residencial, tendo em vista
                      que, com o passar dos anos de vigência do contrato de
                      locação, o valor torna-se defasado ou acima do praticado
                      pelo mercado, com isso, Locador ou Locatário, podem propor
                      a Ação requerendo a adequação do valor para o praticado no
                      mercado. E eventos externos podem ocorrer e podem alterar
                      significativamente o valor do aluguel, por isso, é
                      importante que Locador e Locatário iniciem uma negociação
                      para ajustar o preço e, além disso, é importantíssimo que
                      questões externas, como por exemplo a Pandemia da
                      COVID-19, sejam incluídas em contrato através de cláusula,
                      por meio de aditivo contratual, quando o contrato já
                      estiver vigente.
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/imob-revisional-aluguel.jpg"
                    loading="eager"
                    className="direito-imobilirio-image6"
                  />
                </div>
                <div className="direito-imobilirio-container30">
                  <img
                    alt="image"
                    src="/imob-revisional-financiamento.jpg"
                    loading="eager"
                    className="direito-imobilirio-image7"
                  />
                  <div className="direito-imobilirio-container31">
                    <span className="direito-imobilirio-text39">
                      <span>
                        Ação Revisional de Contrato de Financiamento Imobiliário
                      </span>
                      <br></br>
                    </span>
                    <span className="direito-imobilirio-text42">
                      <span>
                        A ação revisional de financiamento imobiliário é viável
                        quando a instituição financeira, banco ou financiador
                        direto, geralmente a própria construtora ou vendedor
                        pessoa física não cumpre com as disposições contratuais
                        ou prática juros e taxas abusivas. Na maioria das vezes
                        é possível e viável ingressar com ação revisional de
                        contrato de financiamento, sempre embasada em cálculo
                        pericial contábil previamente elaborado por contabilista
                        indicando abuso na cobrança de juros ou da correção
                        monetária, além de podermos discutir as taxas de juros e
                        correção aplicadas.
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer rootClassName="footerroot-class-name8"></Footer>
          <Whatsapp></Whatsapp>
        </main>
      </div>
    </div>
  )
}

export default DireitoImobilirio
